import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.125 2.252h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .622.504 1.125 1.125 1.125h12.75c.621 0 1.125-.503 1.125-1.125v-9m-9.375-9.375h.375a9 9 0 0 1 9 9v.375m-9.375-9.375A3.375 3.375 0 0 1 13.5 5.627v1.5c0 .622.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15.002l2.25 2.25 3.75-5.25"
    }, null, -1)
  ])))
}
export default { render: render }